import { Feature } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import {
  clearBannerSkeleton,
  marqueeSkeletonCard,
  marqueeSkeletonContainer,
  marqueeSkeletonRow,
  marqueeSkeletonTitle,
} from "./hero-banner-skeleton.recipes";

const MARQUEE_SKELETON_CARD_COUNT = 4;

const MarqueeHeroSkeleton = () => (
  <div className={marqueeSkeletonContainer} aria-hidden="true" data-testid="hero-banner-skeleton-id">
    <div className={marqueeSkeletonTitle} />
    <div className={marqueeSkeletonRow}>
      {Array.from({ length: MARQUEE_SKELETON_CARD_COUNT }, (_, index) => index).map((cardIndex) => (
        <div className={marqueeSkeletonCard} key={`marquee-skeleton-card-${cardIndex}`} />
      ))}
    </div>
  </div>
);

const ClearBannerSkeleton = () => (
  <div className={clearBannerSkeleton} aria-hidden="true" data-testid="hero-banner-skeleton-id" />
);

/**
 * Loading placeholder for the home hero while its content fetch is in flight
 * (TMHomeProgressiveCarouselLoadingV2 / exp 103068 variant, where the server skips
 * the hero fetch and the client loads it on mount — see HeroBanner.tsx).
 *
 * Follows the same CXWD_3350 split as HeroBanner so the skeleton matches the shape
 * that will replace it: clear banner block (control) vs marquee card row (variant).
 */
export const HeroBannerSkeleton = () => (
  <Feature
    id={FeatureSetEnum.CXWD_3350_DesktopMarqueeCardsHeroBanner}
    control={() => <ClearBannerSkeleton />}
    variant={() => <MarqueeHeroSkeleton />}
  />
);
